import { instance as axios, setJwtToken, } from "../../config/axiosInstance";

// ------------offer-list-Api-------------------
export const offerListApi = async (data) => {
  const endPoint = `/admin/offer?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};
// ------------offer-change-status-Api-------------------
export const offerChangeStatus = async (id, status) => {
  const endPoint = `/admin/offer/${id}`;
  return await axios.patch(endPoint, status, setJwtToken());
};
// -----------add-promoCode-Api-------------------
export const addOfferApi = async (data) => {
  const endPoint = `/admin/offer`;
  return await axios.post(endPoint, data, setJwtToken());
};
// -----------update-promoCode-Api-------------------
export const updateOfferApi = async (id, data) => {
  const endPoint = `/admin/offer/${id}`;
  return await axios.put(endPoint, data, setJwtToken());
};
// ------------offer-details-Api-------------------
export const fetchOfferDetailsApi = async (id) => {
  const endPoint = `/admin/offer/${id}`;
  return await axios.get(endPoint, setJwtToken());
};
// ------------offer-delete-Api-------------------
export const deleteOfferApi = async (id) => {
  const endPoint = `/admin/offer/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};
